import { useEffect, useState } from "react";
import { VisitRequest } from "@/api/visit-requests";
import { api } from "@/api";
import useErrorHandling from "@/hooks/useErrorHandling";
import { toast } from "react-toastify";
import { TableBuilder } from "@/app/components/tables/tableBuilder";
import { ColumnType } from "@/app/components/tables/tableTypes";
import { Chip, useDisclosure } from "@heroui/react";
import { FaEdit } from "react-icons/fa";
import { EditVisitRequestModal } from "@/app/components/modals/visit-requests/editVisitRequest";

export function VisitRequestsPage() {
  const [visitRequests, setVisitRequests] = useState<VisitRequest[]>([]);
  const [activeRequest, setActiveRequest] = useState<VisitRequest | null>(null);

  useEffect(() => {
    console.log(activeRequest);
  }, [activeRequest]);

  const handleError = useErrorHandling();
  const editRequestModalDisclosure = useDisclosure();

  useEffect(() => {
    api.visitRequests
      .get()
      .then((res) => {
        setVisitRequests(res.data);
      })
      .catch((err) => {
        const { errorMessage } = handleError(err);
        toast.error(errorMessage);
      });
  }, [handleError, editRequestModalDisclosure.isOpen]);

  return (
    <>
      <EditVisitRequestModal
        disclosure={editRequestModalDisclosure}
        visitRequest={activeRequest}
      />
      <div className="flex flex-row flex-wrap gap-4 w-full">
        <div className="flex-grow bg-white dark:bg-zinc-900 rounded-xl border-2 border-foreground-200 dark:border-foreground-100 p-4">
          <div className="flex flex-row justify-between w-full items-center mb-4">
            <div className="flex flex-row gap-4 items-center">
              <span className="font-medium">Заявки</span>
            </div>
          </div>

          <div className="flex flex-col gap-2 mb-2">
            <TableBuilder
              displayOptions={false}
              removeWrapper={true}
              columns={[
                {
                  label: "Имя",
                  key: "name",
                  type: ColumnType.String,
                  sortable: false,
                },
                {
                  label: "Количество сотрудников",
                  key: "team_size",
                  type: ColumnType.Number,
                  sortable: false,
                },
                {
                  label: "Дата просмотра",
                  key: "preferred_visit_date",
                  type: ColumnType.Date,
                  sortable: false,
                },
                {
                  label: "Телефон",
                  key: "phone",
                  type: ColumnType.String,
                  sortable: false,
                },
                {
                  label: "Дата заявки",
                  key: "created_at",
                  type: ColumnType.DateTime,
                  sortable: true,
                  sortKey: "created_at",
                },
                {
                  label: "Статус",
                  key: "status",
                  type: ColumnType.Custom,
                  sortable: true,
                  render: (value) => {
                    return (
                      <Chip
                        color={
                          value === "new"
                            ? "primary"
                            : value === "progress"
                              ? "warning"
                              : value === "done"
                                ? "success"
                                : "default"
                        }
                        variant="flat"
                        size="sm"
                      >
                        {value === "new"
                          ? "Новая"
                          : value === "progress"
                            ? "В процессе"
                            : value === "done"
                              ? "Выполнена"
                              : "Закрыта"}
                      </Chip>
                    );
                  },
                },
                {
                  label: "Действия",
                  key: "actions",
                  type: ColumnType.Actions,
                  sortable: false,
                  actions: [
                    {
                      icon: <FaEdit />,
                      onClick(_value, row) {
                        setActiveRequest(row);
                        editRequestModalDisclosure.onOpen();
                      },
                    },
                  ],
                },
              ]}
              data={visitRequests || []}
              rowsPerPage={10}
              defaultSortDescriptor={{
                column: "created_at",
                direction: "ascending",
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}
